import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AutenticacionService } from '../services/autenticacion.service';
import { FormField } from '../../../dto/util/form-field';
import { FormGroup, Validators } from '@angular/forms';
import { LoginResponseDto } from '../../../dto/auth/login-response.dto';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-doble-factor',
  templateUrl: './modal-doble-factor.component.html',
  styleUrl: './modal-doble-factor.component.scss',
})
export class ModalDobleFactorComponent implements OnInit {
  @ViewChild('modalVerificarCodigoDobleFactor')
  modalVerificarCodigoDobleFactor!: ElementRef;
  @Input() usuarioId?: number | null;
  fieldsVerificarCodigo: FormField[] = [];
  @Output() verificarDobleFactor = new EventEmitter<
    LoginResponseDto | boolean
  >();

  constructor(private autenticacionService: AutenticacionService,private translate: TranslateService) {}

  ngOnInit(): void {
    this.creacionFormulario();
  }

  creacionFormulario() {
    this.fieldsVerificarCodigo = [
      {
        name: 'codigoVerificacion',
        label: this.translate.instant('verificacion-doble-factor.formulario.codigo.label'),
        type: 'text',
        placeholder: this.translate.instant('verificacion-doble-factor.formulario.codigo.placeholder'),
        required: true,
        width: '12',
        visible: true,
        validation: [Validators.maxLength(6), Validators.minLength(6)],
        errorMessages: {
          required: this.translate.instant('verificacion-doble-factor.formulario.codigo.errores.required'),
          maxlength: this.translate.instant('verificacion-doble-factor.formulario.codigo.errores.maxlength'),
          minlength: this.translate.instant('verificacion-doble-factor.formulario.codigo.errores.minlength'),
        },
      },
    ];
  }


  onSubmitVerificarCodigoDobleFactor(form: FormGroup) {
    if (this.usuarioId != null) {
      this.autenticacionService
        .verificarCodigoDobleFactor(this.usuarioId.toString(), {
          codigo: form.get('codigoVerificacion')?.value,
        })
        .subscribe({
          next: (resp: LoginResponseDto) =>
            this.verificarDobleFactor.emit(resp),
          error: error => this.verificarDobleFactor.emit(false),
        });
    }
  }

  abrirCerrarModal() {
    this.modalVerificarCodigoDobleFactor.nativeElement.click();
  }
}
